class FloatingSearch extends HTMLElement {
    constructor() {
        super();

        this.searchOpenedClass = "body-search--open";

        this.footer = document.querySelector('.site-footer-wrapper');
        this.button = this.querySelector('.js-floating-search');
        this.indexSearchWrapper = document.querySelector('#index-main-search');
        this.indexSearchInput = this.indexSearchWrapper.querySelector('.js-index-search-input');
        this.init();
    }

    init() {
        this.handleScroll();
        this.button.addEventListener('click', this.handleClick.bind(this));
        window.addEventListener('scroll', throttle(this.handleScroll.bind(this), 50), {passive: true})
    }

    handleClick(e) {
        e.preventDefault();
        const windowWidth = window.innerWidth;

        if(windowWidth > 768){
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }else{

            //instantly jump to the top to prevent body scroll lock issue on mobile
            window.scrollTo({ top: 0, behavior: 'auto' });
        }
        
        this.indexSearchInput.focus({preventScroll: true});
    }

    handleScroll() {
        const scroll = window.scrollY;
        const body = document.querySelector('body')

        //console.log('scroll:', scroll);

        if(this.isIntersecting(this, this.footer)){
            this.close();
        }else if(scroll > 500 && !body.classList.contains(this.searchOpenedClass)){
            this.open();
        } else {
            this.close();
        }
    }

    close() {
        this.classList.remove('active');
    }

    open() {
        this.classList.add('active');
    }

    isIntersecting(el1, el2) {
        const r1 = el1.getBoundingClientRect();
        const r2 = el2.getBoundingClientRect();

        return !(
            r1.right < r2.left ||
            r1.left > r2.right ||
            r1.bottom < r2.top ||
            r1.top > r2.bottom
        );
    }
  
}
  
customElements.define('floating-search', FloatingSearch);